import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export default class ProyectoService {

  constructor(public db: AngularFirestore) { }

  obtenerProyectos(){
    /*return new Promise<any>((resolve, reject) => {
      this.db.collection('/proyectos').snapshotChanges()
      .subscribe(snapshots => {
        resolve(snapshots)
      })
    })*/
    return this.db.collection('/proyectos').snapshotChanges();
  }

  obtenerProyecto(value){
    //return this.db.collection('/proyectos'//,ref => ref.where('titulo', '==',value.titulo)
    //.where('usuario','==',value.usuario)
    //).snapshotChanges();
    return this.db.collection('/proyectos',ref=> ref.where("titulo","==",value.titulo)).snapshotChanges();
  }

  crearProyecto(value,usuario) {
    return this.db.collection('proyectos').add({
      titulo: value.titulo,
      descripcion: value.descripcion,
      usuario: usuario,
      tipo: value.tipo,
      tags: value.tags,
      publicacion:new Date()
    });
  }
}
